import Color, { knownColors } from "../../enum/Color";
import AnyColor, { HexColor } from "../../types/AnyColor";

import colorNameToHex from "./colorNameToHex";

const anyColorToHex = (color: AnyColor): HexColor =>
  knownColors.includes(color as Color) ? colorNameToHex(color as Color) : (color as HexColor);

export default anyColorToHex;
